const InputField = ({ value, label, name, placeholder, type, onChange, noPadding }) => (
  <div className={["form-group w-full brand-font", `${noPadding ? 'p-0' :'py-5 px-10' }`]}>
    {label && <label htmlFor="input-field ">{label}</label>}
    <input
      type={type}
      value={value}
      name={name}
      className="form-control w-full outline-0 brand-font"
      placeholder={placeholder}
      onChange={onChange}
    />
  </div>
);

export default InputField;